exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(/css/swagger.css);", ""]);

// module
exports.push([module.id, "[data-v-bedd314a] .swagger-ui .info hgroup.main,[data-v-bedd314a] .swagger-ui .topbar,[data-v-bedd314a] .swagger-ui section.models{display:none!important}[data-v-bedd314a] .swagger-ui .info{background-color:transparent!important;border-color:transparent!important;word-break:break-all}.theme--light .main-card[data-v-bedd314a]{background:#fff;-webkit-box-shadow:4px 6px 20px rgba(57,95,169,.18);box-shadow:4px 6px 20px rgba(57,95,169,.18);border-radius:0 15px 15px 15px;padding-top:15px;padding-bottom:15px}.theme--dark .main-card[data-v-bedd314a]{background:#212121;-webkit-box-shadow:none;box-shadow:none;border-radius:0 15px 15px 15px;padding-top:15px;padding-bottom:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bedd314a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/whitelabel/Documentation.vue
// module id = jfj4
// module chunks = 0